<template>
  <v-row justify="center">
    <v-dialog
      content-class="rounded-card"
      v-model="dialog"
      width="1200">
      <template v-slot:activator="{ on }">
        <slot name="activator" v-bind:on="on"></slot>
      </template>
      <v-card outlined class="rounded-card">
        <v-toolbar dense flat>
          <v-toolbar-title class="headline font-weight-bold">
            <v-icon>mdi-cart-variant</v-icon>Carrinho
          </v-toolbar-title>
          <v-spacer></v-spacer>
           <v-btn icon
                  @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-5">
          <px-carrinho-matriz-detalhes :respostas="respostas"
                                       @update-carrinho="emitUpdateCarrinho"/>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { groupBy, first } from 'lodash';
import { DetalheFornecedorUtils } from 'px-components';
import CarrinhoMatrizDetalhes from './CarrinhoMatrizDetalhes.vue';

export default {
  props: {
    produtos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: null,
      respostas: null,
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    emitUpdateCarrinho() {
      this.$emit('update-carrinho');
    },
    buildFornecedor(fornecedor, detalhesFornecedores) {
      const detalhe = DetalheFornecedorUtils.getDetalhe(fornecedor.id, detalhesFornecedores);
      return {
        ...fornecedor,
        codigoInterno: detalhe.codigoInterno,
        pessoa: {
          ...fornecedor.pessoa,
          nome: detalhe.nome || fornecedor.pessoa.nome,
        },
      };
    },
    mapProduto(produto) {
      return {
        produto: { ...produto.produto },
        $melhorFrete: produto.$melhorFrete,
        $melhorPrazoPagamento: produto.$melhorPrazoPagamento,
        $melhorPreco: produto.$melhorPreco,
        $prazoMedio: produto.$prazoMedio,
      };
    },
    mapProdutoRespostas(produtosResposta) {
      const produtoResposta = first(produtosResposta);
      const { detalhesFornecedores } = produtoResposta.resposta.cotacao;

      return {
        ...produtoResposta.resposta,
        fornecedor: this.buildFornecedor(produtoResposta.fornecedor, detalhesFornecedores),
        frete: produtoResposta.frete,
        formaPagamento: produtoResposta.formaPagamento,
        prazoPagamento: produtoResposta.prazoPagamento,
        produtos: produtosResposta.map(p => this.mapProduto(p)),
      };
    },
    buildRespostas() {
      const respostas = groupBy(this.produtos, 'resposta.id');
      this.respostas = Object.keys(respostas).map(key => this.mapProdutoRespostas(respostas[key]));
    },
  },
  mounted() {
    this.buildRespostas();
  },
  components: {
    PxCarrinhoMatrizDetalhes: CarrinhoMatrizDetalhes,
  },
};
</script>
